var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"locale-field-button-wrapper"},[_c('a-button',{class:_vm.hasLocale ? 'i18n-ok' : 'i18n-missing',attrs:{"disabled":!_vm.fieldValue},on:{"click":_vm.openLocale}},[_vm._v(" Localization ")]),_c('locale-field',{ref:"localeField",on:{"localeChange":_vm.onLocaleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }